export default "__VITE_ASSET__1dd38228__"